import { useEffect } from "react";

export default function AuthCallback() {
  useEffect(() => {
    window.close();
  }, []);

  return null;
}
